module.exports = __webpack_public_path__ + "img/29.8257d05d.jpg";